import { IKitchenSettings } from '@backend/domain'
import { ApiProperty } from '@nestjs/swagger'
import { IsNotEmpty } from 'class-validator'

export class KitchenSettings implements IKitchenSettings {
	@ApiProperty({ type: Boolean })
	@IsNotEmpty()
	autoStartCooking: boolean
}
